import { useQuery } from 'react-query';
import { apiClient } from '../api/client';

export interface SuccessRateDataPoint {
  date: string;
  rate: number;
  total_tasks: number;
  successful_tasks: number;
}

export const useSuccessRateTrend = (days: number = 7) => {
  return useQuery<SuccessRateDataPoint[]>(
    ['successRateTrend', days],
    async () => {
      const response = await apiClient.get(
        `/api/v1/scraper/statistics/success-rate-trend?days=${days}`
      );
      return response.data;
    },
    {
      refetchInterval: 300000,
      staleTime: 120000,
      cacheTime: 600000,
    }
  );
};
